"use client";

import CommonButton from "@/components/Button/CommonButton";
import ButtonRightArrow from "@/assets/iconComponents/ButtonRightArrow";
import useContactBoxStore from "@/store/useContactBoxStore";

export default function ContactButton({ text }) {
  const updateContactDialogBoxOpen = useContactBoxStore(
    (state) => state.updateContactDialogBoxOpen
  );

  return (
    <CommonButton
      onClick={() => updateContactDialogBoxOpen(true)}
      text={text}
      bgColor="#B3594D"
      textColor="#EDD2B9"
      className="large-button"
      svgImages={<ButtonRightArrow size={20} color="#EDD2B9" />}
    />
  );
}
